export default __webpack_public_path__ + "static/media/banner_7.ad40f986.jpg";